var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapper",staticStyle:{"overflow-y":"hidden"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',[_vm._v("Validation page for "),_c('a',{attrs:{"href":"https://www.smtp.com/"}},[_vm._v(" SMTP.com ")])])
}]

export { render, staticRenderFns }